import axios from 'axios'
import saveAs from 'file-saver'
import { downloadBlackListCSVEndpoint } from '../services/blackLists/endpoints'
import { logout } from '@/services/auth/endpoints'
import { sessionUserStore } from '../store/session-store/session'
import {router} from "../plugins/router";

// else if (error.response.status == 500){
//   if (router.currentRoute.path != '/signup' ){
//     router.push('/500')
//   }
// }


axios.interceptors.response.use(
  config => {
    return config
  },
  error => {
    if (error.response && error.response.status == 403) {
      const currentPath = router.currentRoute.path;
      if (currentPath !== '/' && currentPath !== '/login') {
        router.push('/403');
      }
    } else if (error.response && error.response.status == 401) {
      if (router.currentRoute.path != '/' && router.currentRoute.path != '/login' && router.currentRoute.path != '/set-password'){
        router.push('/403');
      }
    }
    return Promise.reject(error)
  }
)


function checkStatus(
  response,
  exception
) {
  // if request was made with valid params (i.e method is allowed and URI is correct)
  // but returned with an unsuccessful status
  // throw an error
  return new Promise((resolve, reject) => {
    if (!response) {
      console.error('Request failed with exception:', exception);
      reject({
        data: { error: 'Request failed' },
        status: 500,
        exception
      });
      return;
    }

    if (response.status > 199 && response.status < 300) {
      resolve(response);
    } else {
      if (response.status === 401) {
        sessionStorage.clear();
      }
      reject(response);
    }
  });
}


export default async function request(
  url,
  {
    method = 'GET',
    body = {},
    headers = {},
    isUpload = false,
    accept = 'application/json',
    params = {},
    token = null,
    removeAccept = false,
    blobResponseType = false,
  } = {}
) {
  const storeSession = sessionUserStore();
  const authToken = storeSession.getAuthToken;
  const tokenToUse = token ? token : authToken;
  const request = {
    url: url,
    method: method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: tokenToUse ? `Token ${tokenToUse}` : '',
      ...headers,
    },
    data: !isUpload ? JSON.stringify(body) : body,
    params,
  }

  if (blobResponseType) {
    request.responseType = 'blob'
  }

  if (!removeAccept) {
    request.headers['Accept'] = accept
  }

  if (isUpload) {
    request.headers['Content-Type'] = 'multipart/form-data'
  }

  let response, error;
  try {
    response = await axios(request)
  } catch (e) {
    response = e.response
    error = e
  }
  return checkStatus(response, error)
}


export async function downloadBlackListCSV() {
  const storeSession = sessionUserStore();
  const tokenToUse = storeSession.getAuthToken;
  const request = {
    url: downloadBlackListCSVEndpoint,
    method: 'GET',
    responseType: 'blob',
    headers: {
      Authorization: tokenToUse ? `Token ${tokenToUse}` : '',
    },
  }

  return await axios(request).then((response) => {
    saveAs(new Blob([response.data]), 'Listado_Completo_69-B.csv')
  })
}


export async function downloadRequest(
  url,
  {
    params = {},
  } = {}
) {
  const storeSession = sessionUserStore();
  const authToken = storeSession.getAuthToken;
  const request = {
    url: url,
    headers: {
      Accept: 'application/zip',
      Authorization: authToken ? `Token ${authToken}` : '',
      responseType: 'blob',
    },
    params,

  }

  let response, error;
  try {
    response = await axios(request)
  } catch (e) {
    response = e.response
    error = e
  }
  return checkStatus(response, error)
}

export function parseTableOptionsPagination(tableOptions) {
  let pagination = {}

  if (!tableOptions) return pagination

  if (tableOptions.page) pagination.page = tableOptions.page
  if (tableOptions.itemsPerPage) pagination.page_size = tableOptions.itemsPerPage;

  return pagination
}

export function sendLogbookData(body) {
  return request(logout, {
    method: 'POST',
    body
  })
}
